<div class="header">
    <div class="version-nr" 
    [class.active]="_activeVersionNr$ | async | equals:version" 
    *ngFor="let version of _versionNrs$ | async"
    (click)="_activeVersionNr$.next(version)">{{version}}</div>
</div>
<div class="container scrollable" [innerHTML]="_html"></div>